var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{style:(_vm.customStyle),attrs:{"src":_vm.displaySrc,"alt":_vm.alt}})}
var staticRenderFns = []

export { render, staticRenderFns }